import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import styled from "styled-components";
import { Button } from "primereact/button";
import FileUploadField from "../components/fileUploadField";
import { useTranslation } from "react-i18next";

const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
`;

interface FileUploadDialogProps {
  show: boolean;
  onHide: () => void;
  onAccept: () => void;
  reportId?: number;
  year: number;
  quarter: number | null;
  month: number | null;
}

const FileUploadDialog: React.FC<FileUploadDialogProps> = ({
  show,
  onHide,
  onAccept,
  reportId,
  year,
  quarter,
  month,
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Dialog
      visible={show}
      style={{ minWidth: "700px", minHeight: "364px" }}
      onHide={onHide}
      closeOnEscape={false}
      closable={false}
    >
      <FileUploadField
        existingReportId={reportId}
        onHide={onHide}
        onLoadingChange={setIsLoading}
        propYear={year || undefined}
        propQuarter={quarter || undefined}
        propMonth={month || undefined}
      />
      <DialogActions>
        <Button
          type="button"
          label={t("cmd-close")}
          className="p-button-text"
          onClick={onHide}
          outlined
          disabled={isLoading}
        />
        <Button
          type="button"
          label={t("cmd-save")}
          className="p-button-primary"
          onClick={onAccept}
          disabled={isLoading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default FileUploadDialog;
